var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYourAcct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.5rem",
    height: "2.5rem",
    viewBox: "-1 0 40 40",
    alt: "Customer Online Account Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19,25.6a14.56,14.56,0,0,0,10.6,4.5A14.7,14.7,0,1,0,5.09,15.4a14.31,14.31,0,0,0,4,10C9,25.4,9.09,25.5,9.19,25.6Zm10.6,2.8a13,13,0,0,1-8.4-3.1c3.8-1.3,5.2-2.8,5.8-3.8a6,6,0,0,0,2.4.5h.3a5.26,5.26,0,0,0,2.6-.6c.5,1,1.9,2.6,5.8,3.9A13.64,13.64,0,0,1,19.79,28.4ZM15,12.6h0c.2-4.5,3.5-4.9,4.5-4.9h.3c1,0,4.3.4,4.5,4.8v.1s.4,4.2-1.5,6.3a3.87,3.87,0,0,1-3.1,1.3h0a3.87,3.87,0,0,1-3.1-1.3C14.59,16.8,15,12.6,15,12.6Zm4.8-10.3a13,13,0,0,1,9.8,21.6c-5.5-1.6-5.8-3.6-5.8-3.6h-.1L24,20c2.4-2.6,2-7.2,1.9-7.6-.2-4.7-3.5-6.4-6.2-6.4h-.2c-2.7,0-6,1.7-6.2,6.4,0,.4-.4,5,1.9,7.6.1.2.3.3.4.4-.2.5-1.1,2.1-5.7,3.4a13,13,0,0,1,9.9-21.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,34.6h21.5a.79.79,0,0,0,.8-.8.86.86,0,0,0-.8-.8H9a.8.8,0,0,0,0,1.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.59,37.7a.79.79,0,0,0-.8-.8h-14a.79.79,0,0,0-.8.8.86.86,0,0,0,.8.8h14C27.19,38.6,27.59,38.2,27.59,37.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourAcct);
export default __webpack_public_path__ + "static/media/YourAcct.5eb2c4ef.svg";
export { ForwardRef as ReactComponent };